"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextState = void 0;
function getContextState() {
    return {
        expiryTimeToLive: 599409,
        activeHealthSystemCode: 'CQAT',
        expiryDuration: 600000,
        contexts: [
            {
                organizationId: 1660,
                organizationName: 'CQA TEST',
                organizationCode: 'CQAT',
                organizationType: 'HEALTH_SYSTEM',
                tenantId: 'df9b31e9-702e-4774-bd86-b6b3f4c7a7a9',
                parentLevel: 1,
                healthSystemTenantId: 'df9b31e9-702e-4774-bd86-b6b3f4c7a7a9',
                healthSystemCode: 'CQAT',
                healthSystemName: 'CQA TEST',
                displayName: 'CQA TEST',
                shortDisplayName: 'CQATEST',
                cognitoEnabled: null,
                resources: [
                    {
                        resourceId: 2,
                        resourceName: 'cases',
                        permissionLevel: 'FULL_ACCESS',
                        label: 'Cases',
                        type: 'ui',
                        sequence: 1,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 11,
                        resourceName: 'power_features',
                        permissionLevel: 'FULL_ACCESS',
                        label: 'power_features',
                        type: 'ui',
                        sequence: 3,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 48,
                        resourceName: 'quality_assessment',
                        permissionLevel: 'FULL_ACCESS',
                        label: 'Quality Assessment',
                        type: 'ui',
                        sequence: 49,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 4,
                        resourceName: 'organizations',
                        permissionLevel: 'READ_ONLY',
                        label: 'Organizations',
                        type: 'ui',
                        sequence: 50,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 5,
                        resourceName: 'users',
                        permissionLevel: 'FULL_ACCESS',
                        label: 'Users',
                        type: 'ui',
                        sequence: 51,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 10,
                        resourceName: 'dictionary',
                        permissionLevel: 'READ_ONLY',
                        label: 'Dictionary',
                        type: 'ui',
                        sequence: 55,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 14,
                        resourceName: 'audit_log',
                        permissionLevel: 'FULL_ACCESS',
                        label: 'Audit Log',
                        type: 'ui',
                        sequence: 59,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 15,
                        resourceName: 'code_case',
                        permissionLevel: 'FULL_ACCESS',
                        label: 'Code a case',
                        type: 'ui',
                        sequence: 100,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    },
                    {
                        resourceId: 42,
                        resourceName: 'classification',
                        permissionLevel: 'FULL_ACCESS',
                        label: 'Classification',
                        type: 'ui',
                        sequence: 160,
                        parentId: null,
                        serviceLines: [
                            '*'
                        ],
                        metadata: null
                    }
                ],
                serviceLines: [
                    {
                        id: 1,
                        name: 'Radiology',
                        organizationRelationships: []
                    },
                    {
                        id: 2,
                        name: 'Pathology',
                        organizationRelationships: []
                    },
                    {
                        id: 3,
                        name: 'Surgery',
                        organizationRelationships: []
                    },
                    {
                        id: 28,
                        name: 'Bedside Pro',
                        organizationRelationships: []
                    }
                ]
            }
        ],
        user: {
            id: 9128,
            userId: '812659ce-319e-4f13-8131-8318ef1c45ef',
            username: 'dev+CQATest+cqamanager@codametrix.com',
            password: null,
            confirmPassword: null,
            firstName: 'manager',
            lastName: 'CQATest',
            active: true,
            ignoreLockout: false,
            locked: false,
            passwordExpired: null,
            forcePasswordChange: false,
            entityId: null,
            entityType: null,
            ssoIndicator: false,
            roles: [
                {
                    tenantId: 'df9b31e9-702e-4774-bd86-b6b3f4c7a7a9',
                    organizationName: 'CQA TEST',
                    roles: [
                        {
                            id: 18,
                            roleName: 'cqa_coder',
                            roleDescription: 'CQA Coder',
                            primaryRole: null
                        },
                        {
                            id: 17,
                            roleName: 'cqa_manager',
                            roleDescription: 'CQA Manager',
                            primaryRole: null
                        }
                    ],
                    displayName: 'CQA TEST'
                }
            ]
        },
        activeContextId: 1660,
        activeContext: {
            organizationId: 1660,
            organizationName: 'CQA TEST',
            organizationCode: 'CQAT',
            organizationType: 'HEALTH_SYSTEM',
            tenantId: 'df9b31e9-702e-4774-bd86-b6b3f4c7a7a9',
            parentLevel: 1,
            healthSystemTenantId: 'df9b31e9-702e-4774-bd86-b6b3f4c7a7a9',
            healthSystemCode: 'CQAT',
            healthSystemName: 'CQA TEST',
            displayName: 'CQA TEST',
            shortDisplayName: 'CQATEST',
            cognitoEnabled: null,
            resources: [
                {
                    resourceId: 2,
                    resourceName: 'cases',
                    permissionLevel: 'FULL_ACCESS',
                    label: 'Cases',
                    type: 'ui',
                    sequence: 1,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 11,
                    resourceName: 'power_features',
                    permissionLevel: 'FULL_ACCESS',
                    label: 'power_features',
                    type: 'ui',
                    sequence: 3,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 48,
                    resourceName: 'quality_assessment',
                    permissionLevel: 'FULL_ACCESS',
                    label: 'Quality Assessment',
                    type: 'ui',
                    sequence: 49,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 4,
                    resourceName: 'organizations',
                    permissionLevel: 'READ_ONLY',
                    label: 'Organizations',
                    type: 'ui',
                    sequence: 50,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 5,
                    resourceName: 'users',
                    permissionLevel: 'FULL_ACCESS',
                    label: 'Users',
                    type: 'ui',
                    sequence: 51,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 10,
                    resourceName: 'dictionary',
                    permissionLevel: 'READ_ONLY',
                    label: 'Dictionary',
                    type: 'ui',
                    sequence: 55,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 14,
                    resourceName: 'audit_log',
                    permissionLevel: 'FULL_ACCESS',
                    label: 'Audit Log',
                    type: 'ui',
                    sequence: 59,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 15,
                    resourceName: 'code_case',
                    permissionLevel: 'FULL_ACCESS',
                    label: 'Code a case',
                    type: 'ui',
                    sequence: 100,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                },
                {
                    resourceId: 42,
                    resourceName: 'classification',
                    permissionLevel: 'FULL_ACCESS',
                    label: 'Classification',
                    type: 'ui',
                    sequence: 160,
                    parentId: null,
                    serviceLines: [
                        '*'
                    ],
                    metadata: null
                }
            ],
            serviceLines: [
                {
                    id: 1,
                    name: 'Radiology',
                    organizationRelationships: []
                },
                {
                    id: 2,
                    name: 'Pathology',
                    organizationRelationships: []
                },
                {
                    id: 3,
                    name: 'Surgery',
                    organizationRelationships: []
                },
                {
                    id: 28,
                    name: 'Bedside Pro',
                    organizationRelationships: []
                }
            ],
            serviceLineName: 'Bedside Pro'
        },
        jwtToken: 'token',
        expiryTimestamp: 1742498478804,
        serviceLineName: 'Bedside Pro'
    };
}
exports.getContextState = getContextState;
//# sourceMappingURL=context.js.map